// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2421":"056c2d43c00498f3","3258":"6ba76f00451a11be"}[chunkId] + ".css";
};